 
export const environment = {
    vhost_alias: "https://cascade.cmcc-opa.eu"
  };



// WEBPACK FOOTER //
// ./src/providers/connector/environment.ts